export const Placeholder = ({ label = "", className = "" }) => (
  <div className={`relative w-full h-full flex flex-col items-center justify-center bg-panel overflow-hidden ${className}`}>
    <div className="absolute inset-0 bg-[radial-gradient(#262626_1px,transparent_1px)] [background-size:16px_16px] opacity-40" />
    <span className="relative font-display font-extrabold uppercase text-outline text-6xl sm:text-7xl tracking-tighter select-none">M66</span>
    <span className="relative mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">Photographie à venir</span>
    {label && (
      <span className="relative mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-600 px-4 text-center">{label}</span>
    )}
  </div>
);

export default Placeholder;
